export default function useAppLocalization() {
  const { locale, locales } = useI18n({
    useScope: 'global',
  })
  const switchLocalePath = useSwitchLocalePath()
  const localePath = useLocalePath()
  const route = useRoute()

  const currentLocale = computed(() => {
    return locales.value.find((i) => i.code === locale.value)
  })

  const alternateLocale = computed(() => {
    return locales.value.find((i) => i.code !== locale.value)
  })

  async function toggleLocale() {
    const targetLocale = alternateLocale.value?.code

    if (!targetLocale) {
      return
    }

    if (route.meta?.i18n && !route.meta?.i18n?.paths?.[targetLocale]) {
      await navigateTo(localePath({ name: 'index' }, targetLocale))
      return
    }

    const path = switchLocalePath(targetLocale) || localePath({ name: 'index' }, targetLocale)
    await navigateTo(path)
  }

  return {
    alternateLocale,
    currentLocale,
    toggleLocale,
  }
}
